import * as React from 'react';

const Document16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.25 4A.75.75 0 0 1 5 3.25h6a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 4m0 4A.75.75 0 0 1 5 7.25h6a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 8m0 4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13 1.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5zM3 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
  }
));
Document16.Size = 16;
Document16.Title = "Document";

export { Document16 as default };
